module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-sidebar"
  }, [_c('b-navbar', {
    staticClass: "responsive-sidebar"
  }, [_c('b-navbar-toggle', {
    staticClass: "sidenav-toggle",
    attrs: {
      "target": "sidenav_id"
    }
  }), _vm._v(" "), _c('b-collapse', {
    ref: "sidenav_id",
    attrs: {
      "is-nav": "",
      "id": "sidenav_id"
    }
  }, [_c('b-navbar-nav', {
    on: {
      "click": _vm.hideNavigation
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": "dashboard"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")]), _vm._v(" Dashboard\n                ")]), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.allInvoices')) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.groupSettlement')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.userAdministration')) + "\n                ")]), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.userRegistration')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")]), _vm._v(" " + _vm._s(_vm.$t('sidebar.reportedIssues')) + "\n                ")]), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('b-nav-item', {
    attrs: {
      "to": "/settle-invoice"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("monetization_on")]), _vm._v(_vm._s(_vm.$t('sidebar.invoiceSettlement')) + " "), _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Test")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('b-nav-item', {
    attrs: {
      "to": "/intervention"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("build")]), _vm._v(_vm._s(_vm.$t('sidebar.intervention')) + " "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Admin")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [(_vm.showCollapse) ? _c('div', [_c('nav', {
    staticClass: "sidebar"
  }, [_c('ol', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")]), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.allInvoices')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim || _vm.hasInvoiceReviewAllClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.groupSettlement')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdministrativePrivileges) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.userAdministration')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.userRegistration')))])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.reportedIssues')))])])], 1), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settle-invoice"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("monetization_on")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.invoiceSettlement')) + " "), _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Test")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/intervention"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("build")]), _c('span', [_vm._v(_vm._s(_vm.$t('sidebar.intervention')) + " "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Admin")])], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('b-row', {
    staticClass: "treasury-logo ml-2 text-center",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  })]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('div', {
    staticClass: "pb-2"
  }, [_c('label', [_vm._v("РЕПУБЛИКА СРБИЈА")]), _vm._v(" "), _c('label', [_vm._v("МИНИСТАРСТВО ФИНАНСИЈА")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-weight": "800"
    }
  }, [_vm._v("УПРАВА ЗА ТРЕЗОР")])])])], 1)], 1)]) : _c('div', [_c('nav', {
    staticClass: "sidebar-collapsed"
  }, [_c('ol', [_c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/dashboard",
      "exact": "",
      "title": "Dashboard"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("dashboard")])])], 1), _vm._v(" "), (_vm.hasInvoiceReviewClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.allInvoices')),
      expression: "$t('sidebar.allInvoices')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/invoices"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("description")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGroupSettlementCreateClaim || _vm.hasInvoiceReviewAllClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.groupSettlement')),
      expression: "$t('sidebar.groupSettlement')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/group-settlement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("next_week")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdministrativePrivileges) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.userAdministration')),
      expression: "$t('sidebar.userAdministration')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/user-administration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("supervisor_account")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreateClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.userRegistration')),
      expression: "$t('sidebar.userRegistration')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/user-registration"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("business")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: (_vm.$t('sidebar.reportedIssues')),
      expression: "$t('sidebar.reportedIssues')",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/reported-issues"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])])], 1), _vm._v(" "), (_vm.hasInvoiceCreateClaim && _vm.isTestEnvironment) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/settle-invoice",
      "title": "$t('sidebar.invoiceSettlement')"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("monetization_on")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAdminClaim) ? _c('li', [_c('router-link', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "to": "/intervention",
      "title": "$t('sidebar.intervention')"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("build")])])], 1) : _vm._e()]), _vm._v(" "), _c('b-row', {
    staticClass: "treasury-logo ml-2 text-center",
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('b-btn', {
    class: {
      'button-class': _vm.showCollapse, 'button-class-collapsed': !_vm.showCollapse
    },
    attrs: {
      "id": "collapse-button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v(_vm._s(_vm.buttonLabel))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcc03e3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/side-nav/SideNav.vue
// module id = 785
// module chunks = 1